/**
 * AWS Configuration object for connecting to AWS services.
 *
 * @type {Object}
 * @property {string} accessKeyId - The AWS access key ID.
 * @property {string} secretAccessKey - The AWS secret access key.
 * @property {string} region - The AWS region.
 */
export const awsConfiguration = {
  accessKeyId: import.meta.env.VITE_REACT_APP_KENDRA_ACCESS_KEY_ID,
  secretAccessKey: import.meta.env.VITE_REACT_APP_KENDRA_SECRET_ACCESS_KEY,
  region: 'us-east-1'
}

/**
 * Facet Configuration object for rendering facets in the KENSearch results.
 */
export const facetConfiguration = {
  /*
   * The max number of facets to show when uncollapsed
   */
  facetsToShowWhenUncollapsed: 5,

  /*
   * The max number of facets that can be selected
   */
  maxSelectedFacets: 5,

  /*
   * true: show the count of results of each facet
   * false: NOT show the count of results of each facet
   */
  showCount: true,

  /*
   * true: the available facets will be updated upon filter selections change
   * false: the available facets will NOT be updated upon filter selections change
   */
  updateAvailableFacetsWhenFilterChange: true,

  /*
   * true: facet panel will be expanded by default
   * false: facet panel will be collapsed by default
   */
  facetPanelDefaultOpen: false,
};

/**
 * UI Configuration object for rendering various components in the KENSearch results.
 *
 * @type {Object}
 * @property {boolean} showFacets - Whether to show facets in the search results.
 * @property {boolean} showSorting - Whether to show sorting options in the search results.
 * @property {boolean} showPagination - Whether to show pagination in the search results.
 * @property {boolean} showPageIndex - Whether to show page index in the search results.
 * @property {boolean} showTopResults - Whether to show top results in the search results.
 * @property {boolean} showFAQResults - Whether to show FAQ results in the search results.
 * @property {boolean} showDocumentResults - Whether to show document results in the search results.
 * @property {boolean} showGenAIResult - Whether to show GenAI results in the search results.
 */
export const resultsConfiguration = {
  documentResultsOptions: {
    answerFontSize: null
  },
  enableFacets: false,
  enableSorting: true,
  enablePagination: true,
  enablePageIndex: true,
  showTopResults: false,
  showFAQResults: false,
  showDocumentResults: true,
  showGenAIResult: false,
}

